import { useMutation } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import type { MessageInterface } from "types/message";
import { createMessageRequest, getMessageRequest } from "lib/api/message";

export const fetchMessage = (id: string) =>
    parseResponse<Array<MessageInterface>>(getMessageRequest(id));

export const createMessage = (data: HashMap<unknown>) =>
    parseResponse<MessageInterface>(createMessageRequest(data));

export const messageKeys = {
    all: ["message"] as const,
};

export const useCreateMessage = () =>
    useMutation({
        mutationFn: (data: HashMap<unknown>) => createMessage(data),
    });
